export default function reducer(state = {}, action = {}) {
  return state;
}
